import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import { IconVerified } from '@/components/custom/icon';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { Filter, FilterContent, FilterHat, FilterTitle } from '@/components/custom/filter';
import { PlayfulNavContext } from '@/lib/playful-nav-context';

export default function Breadcrumbs(props) {
  const { data, actions, innerContent } = props;

  // Só na navegação lúdica (aluno) a logo fica no header e o breadcrumb encosta
  // nela (left-164 + borda-l vertical). Admin/professor usam a sidebar, então o
  // breadcrumb segue o layout corporativo: sem espaço de logo e sem linha vertical.
  const playfulNav = React.useContext(PlayfulNavContext);
  const breadcrumbClass = playfulNav
    ? 'gap-0 md:fixed md:left-[175px] md:top-[38px] md:z-[105] md:mb-0 md:w-auto md:max-w-[44vw] md:overflow-hidden md:border-l md:border-neutral-lighter md:!pl-5 md:border-b-0 md:pb-0'
    : 'gap-0 md:fixed md:left-16 md:right-0 md:top-8 md:z-[105] md:mb-0 md:w-[calc(100vw-324px-64px)] md:overflow-hidden md:border-b-0 md:!pl-11 md:pb-0';

  return (
    <Filter
      variant="plain"
      aria-label="breadcrumb"
      className={breadcrumbClass}
    >
      {data?.title && <FilterHat>{data?.title}</FilterHat>}

      <FilterContent className="md:flex-nowrap">
        {data?.nav?.map((item, index, arr) => {
          const lastItem = index === arr.length - 1;

          return lastItem ? (
            <ButtonBack
              key={index}
              className="cursor-default"
              title={item?.name}
              disabled={!item?.isActive}
            >
              <ButtonBackContent>
                <FilterTitle>
                  {item?.name} {item?.['official-content'] && <IconVerified />}
                </FilterTitle>
              </ButtonBackContent>
            </ButtonBack>
          ) : (
            <ButtonBack
              key={index}
              title={item?.name}
              disabled={!item?.isActive}
              asChild
            >
              <Link to={item.route || '#'}>
                <ButtonBackContent>
                  <FilterTitle>
                    {item?.name} {item?.['official-content'] && <IconVerified />}
                  </FilterTitle>
                </ButtonBackContent>

                <IconWrapper size="sm">
                  <FiChevronLeft />
                </IconWrapper>
              </Link>
            </ButtonBack>
          );
        })}

        {innerContent && innerContent}
      </FilterContent>

      {actions && actions}
    </Filter>
  );
}
